import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/index';
import { getRTL } from '@yme/selectors/common';
import { ComponentHolder } from '@yme/tokens/flexTokens';
import { AspectRatio } from '@yme/utils/constants';
import { AppFrame } from './AppFrame';
import { PreviewContent } from './PreviewContent';
import { DEFAULT_IMAGE_PROPS } from './constants';
import { ImageBgInnerStyled, ImageBgStyled, PreviewContentStyled } from './styled';
export function AppSection(props) {
    const { title, subtitle, description, googlePlayLink, appStoreLink, appImage, // Object for frame App - AppImage Component
    backgroundImage, labels, frameType, isRemoveBottomIndent, } = props;
    const imageProps = {
        ...DEFAULT_IMAGE_PROPS,
        ...backgroundImage,
        errorPlaceholderHasBackground: true,
        errorPlaceholderAspectRatio: AspectRatio.Auto,
    };
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView } = useWindowSize();
    const positionValue = isMobileView ? 'static' : 'relative';
    if (frameType && appImage && (googlePlayLink || appStoreLink)) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(ComponentHolder, { position: positionValue },
                React.createElement(AppFrame, { isRightToLeft: isRightToLeft, appImage: appImage, frameType: frameType }),
                React.createElement(Container, { isRightToLeft: isRightToLeft },
                    React.createElement(Row, null,
                        React.createElement(Col, { md: 4, lg: 6 },
                            React.createElement(PreviewContentStyled, { isRightToLeft: isRightToLeft },
                                React.createElement(PreviewContent, { isRightToLeft: isRightToLeft, title: title, subtitle: subtitle, description: description, googlePlayLink: googlePlayLink, appStoreLink: appStoreLink, labels: labels }))),
                        !isMobileView && (React.createElement(Col, { md: 4, lg: 6 },
                            React.createElement(ImageBgStyled, { isRightToLeft: isRightToLeft },
                                React.createElement(ImageBgInnerStyled, null,
                                    React.createElement(Image, { ...imageProps }))))))))));
    }
    return null;
}
AppSection.displayName = 'AppSection_AEMComponent';
